(function ($) {
	$(() => {
		let slider,
			that,
			sticky,
			stop,
			check,
			scrollVal,
			last,
			loop = 0;


		$(".slider .offsetBlock").css({
			"width": ($(window).width() - $(".sliders .to--center").width()) / 2 - 30
		});

		initSlider(".slider")


		$(".step").on("click", function () {
			slider = $(this).parents(".block").find(".slider");
			if ($(this).hasClass("left")) {
				slider.slick('slickPrev');
			} else {
				slider.slick('slickNext');
			}
		});

		$(".faqTitle").on("click", function () {
			$(this).parent().toggleClass("visible");
			$(this).next().slideToggle();
		});

		function initSlider(el, re = false) {
			if (re) {
				$(el).find(".offsetBlock").remove()
			}
			if ($(window).width() < 990) {
				$(".offsetBlock").remove()
			}
			$(el).slick({
				dots: false,
				arrows: false,
				infinite: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 2,
				centerMode: false,
				variableWidth: true,
				autoplay: false,
				autoplaySpeed: 2000,
				responsive: [
					{
						breakpoint: 1400,
						settings: {
							slidesToScroll: 2,
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 990,
						settings: {
							slidesToScroll: 1,
							slidesToShow: 1,
						}
					},
					{
						breakpoint: 520,
						settings: {
							slidesToScroll: 1,
							slidesToShow: 1,
						}
					}
				]
			});
		}

		$(".order-select").SumoSelect();


		$('.js-change-view').on('change', function (e) {
			var $val = $(this).val();

			if ($val == 1) {
				$('.js-program-list').show();

				$('.js-artist-list').hide();
			} else {
				$('.js-artist-list').show();

				$('.js-program-list').hide();
			}

		})

		$(".mobile__menu").on("click", function () {
			$(".mobile__navigation").addClass("visible");
		});

		$(".mobile__navigation .close").on("click", function () {
			$(".mobile__navigation").removeClass("visible");
		});


		$('.jumpButtons').stickySidebar({
			topSpacing: 10,
			bottomSpacing: 40
		});

		$(".jumpButtons .jump").on("click", function () {
			check = $(this).data("jump");
			stop = $("[data-stop=" + check + "]").offset().top - 10
			$("body, html").animate({ scrollTop: stop }, { duration: "normal" })
		});

		$(window).on("scroll", function () {
			if ($('.jumpButtons').length) {
				scrollVal = $(window).scrollTop();
				last = 1
				$("[data-stop]").each(function () {
					if ($(this).offset().top - 20 < scrollVal) {
						last = $(this).data("stop")
					}
				});
				$("[data-jump]").removeClass("active")
				$("[data-jump=" + last + "]").addClass("active")
			}
		});
		$(".submenu__wrapper li").each(function () {
			$(".submenu__wrapper .grid .col").eq(loop).append($(this).html());
			if (loop < 4) {
				loop++
			} else {
				loop = 0
			}
		});

		$(".menu-item-has-children > a").on("click", function (e) {
			if ($(this).attr("href") == "#") {
				e.preventDefault();
				$(this).toggleClass("showNext")
			}
		});

	});


	if ($(".js-mh-product-title").length) {
		$(".js-mh-product-title").matchHeight({
			byRow: true
		});
	}



	if ($(".js-mh-price").length) {
		$(".js-mh-price").matchHeight({
			byRow: true
		});
	}


	if ($(".js-mh-price-old").length) {
		$(".js-mh-price-old").matchHeight({
			byRow: true
		});
	}


	$('.js-filter-toggle').on('click', function (e) {
		e.preventDefault();
		$('.js-filter-toggle-wrapper').slideToggle();
		$('main').toggleClass("zplus");
		$('body').toggleClass("o-hidden");
	})


	$('.js-sidebar').stickySidebar({
		topSpacing: $('header').outerHeight(),
		bottomSpacing: 0,
		containerSelector: '.sidebar__container',
		innerWrapperSelector: '.plus-sidebar-wrapper',
		resizeSensor: true,
		minWidth: 992,
	});

	objectFitImages();
})(jQuery);

function grabFormAsObject(jqueryForm, limitToFields = []) {
	var data = jqueryForm.serializeArray();
	var obj = {};
	data.forEach(function (item) {
		obj[item.name] = item.value;
	});
	return obj;
}
